import { usePmsTheme } from "../../Components/PmsThemeContext";
import PosCatalogTab from "../components/tabs/PosCatalogTab";
import { ITEMS_FAMILIES_UI_STYLES } from "../components/itemsFamiliesUi";
import "../PurchasingUi.css";
import "./CatalogWorkspace.css";

export default function PosItems() {
  const { themeId } = usePmsTheme();
  return (
    <div className="pilcore-purchasing-ui pu-catalog spx-shell" data-theme={themeId}>
      <style>{ITEMS_FAMILIES_UI_STYLES}</style>
      <div className="ifm-page">
        <PosCatalogTab />
      </div>
    </div>
  );
}
